import React from 'react'

import clsx from 'clsx'

import EmptyState from 'components/EmptyState'
import Icon from 'components/Icon'
import Link from 'components/Link'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'
import { formatRatingAverage, kFormatter } from 'helpers/formatters'
import { getengagementDestination } from 'helpers/reviews'

import classes from './RatingDisplay.module.scss'

/** @type {import("./types").default} */
const RatingDisplay = ({
  title,
  className,
  isListingDetail = true,
  href,
  rating = 0,
  totalNumberOfReviews = 0,
  customEvent,
  hasDenominator = true,
  enableLink = true,
}) => {
  const ratingFormatted = formatRatingAverage(rating)
  const eventContext = useEventContext()
  const event =
    customEvent ||
    eventContext.addEvent({
      engagementDestination: getengagementDestination(href, { isListingDetail }),
      engagementDetails: 'text-link_number-reviews',
    })

  const linkContent = (
    <>
      <Icon className={clsx(classes.userIcon, { [classes.disabled]: !enableLink })} icon={['far', 'user']} size="12" />
      <span className={classes.reviewsNumber}>{kFormatter(totalNumberOfReviews)}</span>
    </>
  )

  return (
    <div className={clsx('RatingDisplay', classes.root, className)}>
      {title && <p className={classes.title}>{title}</p>}
      {totalNumberOfReviews > 0 && ratingFormatted > 0 ? (
        <>
          <div className={classes.rating}>
            <Icon icon="star" className={classes.star} size="24" />
            <Typography variant="display-sm" className={classes.number}>
              {ratingFormatted}
            </Typography>
            {hasDenominator && (
              <Typography variant="body-sm" className={classes.ratingNumDenominator}>
                /5
              </Typography>
            )}
          </div>
          {enableLink ? (
            <Link className={classes.link} href={href} {...event}>
              {linkContent}
            </Link>
          ) : (
            <p className={classes.disabled}>{linkContent}</p>
          )}
        </>
      ) : (
        <EmptyState className={classes.emptyState} />
      )}
    </div>
  )
}

export default RatingDisplay
